import { Observable } from 'rxjs';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlHelperService } from '@core/services/url-helper.service';
import { environment } from '@environments/environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    private readonly rootDomain: string;
    private readonly market: string;
    private readonly globalApiVersion: string = 'v1';
    private readonly microServices: Set<string> = new Set(['orders-ms', 'search-ms', 'customers-ms']);

    constructor(private urlHelper: UrlHelperService) {
        this.rootDomain = environment.production ? this.urlHelper.getRootDomain() : environment.apiDomain;
        this.market = this.urlHelper.getCurrentMarket;
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isAbsolute = req.url.includes('http');

        if (isAbsolute) {
            return next.handle(req);
        }

        const msRoute = this.microServiceRoute(req.url);

        const apiRoute = `https://api.${this.rootDomain}/${this.market}${this.getVersionSegment(req.url)}${req.url}`;
        const route = msRoute ? msRoute : apiRoute;

        return next.handle(
            req.clone({
                url: route
            })
        );
    }

    private microServiceRoute(url: string): string | null {
        const [msRoute, ...rest] = url.split('/');

        if (!this.microServices.has(msRoute)) {
            return null;
        }

        const [msSubdomain] = msRoute.split('-');

        return `https://${msSubdomain}.${this.rootDomain}/api/${this.market}${this.getVersionSegment(url)}${rest.join(
            '/'
        )}`;
    }

    /**
     * Check for applied version if version exists use it, if not fallback to globalApiVersion
     * @param url
     */
    private getVersionSegment(url: string): string | null {
        const paths = url.split('/');

        const hasVersion = paths.some(path => path.match(/^[vV][1-9]$/));

        return hasVersion ? '/' : `/${this.globalApiVersion}/`;
    }
}
